<div class="customer-documents-list-card">
  <div class="customer-documents-list-card__header" ubi-curve-header xlarge>
    <div class="customer-documents-list-card__header-text">
      {{ 'document_list.header' | translate }}
    </div>
    <div class="customer-documents-list-card__header-sub-text" *ngIf="(currentCustomer$ | async) || (currentCRP$ | async)">
      {{((currentCRP$ | async) || (currentCustomer$ | async))?.name}}
    </div>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('document_list.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="customer-documents-list-card__content">
    <artemis-loading-spinner *ngIf="!record || (!loading$ | async)"></artemis-loading-spinner>
    <button mat-button class="btn btn_accent-gradient-rounded customer-documents-list-card__add-new" ubi-round-button (click)="addDocument()">
      + {{ 'document_list.button' | translate }}
    </button>
    <div class="customer-documents-table__container">
      <div class="customer-documents-table__wrapper">
        <table class="custom-mat-table customer-documents-table" mat-table matSort
          [dataSource]="customerDocumentsDataSource">

          <ng-container matColumnDef="showExpiryAlerts">
            <th class="customer-documents-table__column-file-view" mat-header-cell *matHeaderCellDef>
              {{ 'general.table.label.expiry_alert' | translate }}
            </th>
            <td class="customer-documents-table__cell customer-documents-table__column-file-view" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.showExpiryAlerts || ''">
              <mat-slide-toggle class="custom-mat-slide-toggle name-table__toggle" [checked]="customerDocument.showExpiryAlerts" (change)="toggleNotification(customerDocument.id, $event)"></mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="file">
            <th class="customer-documents-table__column-file-view" mat-header-cell *matHeaderCellDef> {{ 'general.table.label.file' | translate }} </th>
            <td class="customer-documents-table__cell customer-documents-table__column-file-view" mat-cell *matCellDef="let customerDocument">
              <ng-container *ngIf="customerDocument.document">
                <a class="link" [ngClass]="{'link_disabled': !customerDocument.document}" [href]="customerDocument.document" title="View document" target="_blank">
                  {{ 'general.table.label.front' | translate  }}
                </a>
                <a *ngIf="customerDocument.backDocument" class="link" [ngClass]="{'link_disabled': !customerDocument.backDocument}" [href]="customerDocument.backDocument" title="View back document" target="_blank">/
                  {{ 'general.table.label.back' | translate }}
                </a>
              </ng-container>
              <ng-container *ngIf="!customerDocument.document">
                <span class="customer-documents-table__disabled-link"> {{ 'general.table.label.na' | translate }} </span>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="doc_number">
            <th class="customer-documents-table__column-file-view" mat-header-cell *matHeaderCellDef> {{ 'general.table.label.document_number' | translate }} </th>
            <td class="customer-documents-table__cell customer-documents-table__column-doc-number" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.documentNumber || ''">
              {{customerDocument.documentNumber || '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="doc_type">
            <th class="customer-documents-table__column-document-type" mat-header-cell *matHeaderCellDef> {{ 'general.table.label.type' | translate }} </th>
            <td class="customer-documents-table__cell customer-documents-table__column-document-type" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.docType || ''">
              {{customerDocument.docType || '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="authenticity">
            <th class="customer-documents-table__column-document-authenticity" mat-header-cell *matHeaderCellDef
              mat-sort-header> {{ 'general.table.label.authenticity' | translate }} </th>
            <td class="customer-documents-table__cell customer-documents-table__column-document-authenticity" mat-cell
              *matCellDef="let customerDocument" [title]="customerDocument.authenticity || ''">
              {{customerDocument.authenticity || '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="issue_date">
            <th class="customer-documents-table__column-issue-date" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'general.table.label.issue_date' | translate }}
            </th>
            <td class="customer-documents-table__cell customer-documents-table__column-issue-date" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.issueDate ? (customerDocument.issueDate  | date:'dd/MM/yyyy') : ''">
              {{customerDocument.issueDate ? (customerDocument.issueDate | date:'dd/MM/yyyy') : '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="expiry_date">
            <th class="customer-documents-table__column-expiry-date" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'general.table.label.expiry_date' | translate }}
            </th>
            <td class="customer-documents-table__cell customer-documents-table__column-expiry-date" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.expiryDate ? (customerDocument.expiryDate | date:'dd/MM/yyyy') : ''">
              <img class="customer-documents-table__icon customer-documents-table__icon_expiring"
                src="/assets/icons/exclamation-icon-accent.png" *ngIf="checkDocumentExpiring(customerDocument)" />
              {{customerDocument.expiryDate ? (customerDocument.expiryDate | date:'dd/MM/yyyy') : '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="updated_at">
            <th class="customer-documents-table__column-updated-date" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'general.table.label.updated_at' | translate }}
            </th>
            <td class="customer-documents-table__cell customer-documents-table__column-updated-date" mat-cell *matCellDef="let customerDocument"
              [title]="customerDocument.updatedAt ? (customerDocument.updatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : ''">
              {{customerDocument.updatedAt ? (customerDocument.updatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : ''}}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th class="customer-documents-table__column-actions" mat-header-cell *matHeaderCellDef> {{ 'general.table.label.edit' | translate }} </th>
            <td class="customer-documents-table__cell customer-documents-table__column-actions" mat-cell *matCellDef="let customerDocument">
              <a class="link" title="Edit Document" (click)="editDocumentClick(customerDocument)">
                <img class="themified-white-icon customer-documents-table__icon customer-documents-table__icon_edit"
                  src="/assets/icons/edit-icon.png" />
              </a>
              <a class="link" title="Edit Document">
                <img class="themified-white-icon customer-documents-table__icon customer-documents-table__icon_remove" src="/assets/icons/minus-icon-white.png" title="Delete"
                (click)="deleteDocument(customerDocument.id)">
              </a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'customer-documents-table__notification-dismissed-row': !row.showExpiryAlerts}"></tr>
        </table>
      </div>
      <div class="table-empty" *ngIf="paginator.length === 0">
        {{ 'document_list.message' | translate }}
      </div>
      <mat-paginator class="custom-mat-paginator" showFirstLastButtons [pageSizeOptions]="pageSizeOptions">
      </mat-paginator>
    </div>
  </div>
</div>
